import { render, staticRenderFns } from "./SupporterViewAddresses.vue?vue&type=template&id=fe3a00f6&"
import script from "./SupporterViewAddresses.vue?vue&type=script&lang=js&"
export * from "./SupporterViewAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports